<script>
	export let progress;
  export let unit;
  export let value;
	const angle = 360 * progress;
    // console.log(progress)
	
	// Adapt the logic according to the approach
	const	background = `
        radial-gradient(white 50%, transparent 51%),
        conic-gradient(transparent 0deg ${angle}deg, gainsboro ${angle}deg 360deg),
        conic-gradient(orange 0deg, yellow 90deg, lightgreen 180deg, green);`
	
	$: cssVarStyles = `--background:${background}`
</script>

<style>
  #progress-circle {
    background: var(--background);
    border-radius: 50%;
    width: 180px;
    height: 180px;
    transition: all 100ms ease-in;
    will-change: transform;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
  }

  .unit {
    font-size: 1.2em;
    font-weight: bold;
    color: grey;
  }

  .value {
    font-size: 50px;
    font-weight: bold;
    font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    color: grey;
  }

  
</style>

<div id="progress-circle" style="{cssVarStyles}">
  <div>
    <div class="unit">{unit}</div>
    <div class="value">{value}</div>
  </div>
</div>